import * as React from "react";
import { useDebounce } from "../../hooks/useDebounce";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import Box from "@mui/material/Box";
import { InputAdornment, TextField, makeStyles } from "@material-ui/core";
import { getProductDetails, getShopDetails } from "../../service/service";
import usePageVisibility from "../../hooks/usePageVisibility";
import OutletCard from "./outletCard";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBarcode } from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Card, Typography, theme, Button, Select } from "antd";
import AddOutlet from "./addOutlet";
import { useDispatch, useSelector } from "react-redux";
import ColorPicker from "rc-color-picker";
import "rc-color-picker/assets/index.css";
import { useEffect, useState, useCallback } from "react";
import Auth from "@aws-amplify/auth";
import Barcode from "react-barcode";
import config from "../../config";
import useLocalStorage from "../../hooks/useLocalstorage";
import { useLocation } from "react-router-dom";
import {
  AiOutlineBgColors,
  AiOutlineUnderline,
  AiOutlineItalic,
} from "react-icons/ai";
//import {html2canvas} from "html2canvas";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import {
  MdOutlineRadioButtonUnchecked,
  MdOutlineRadioButtonChecked,
} from "react-icons/md";
import {
  GrTextAlignCenter,
  GrTextAlignLeft,
  GrTextAlignRight,
} from "react-icons/gr";
import { RiBarcodeLine, RiArrowDownSLine } from "react-icons/ri";
library.add(faBarcode);
const useStyles = makeStyles((theme) => ({
  tabs: {
    "& .css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected": {
      background: "#FFFFFF !important",
    },
    "& button": {
      padding: "1.5rem 2rem",
    },
  },
}));

// const pageStyle = `
// @page {
//   size: 25mm 35mm portrait;
// }

// @media all {
//   .pagebreak {
//     display: none;
//   }
// }

// @media print {
//   .pagebreak {
//     page-break-before: avoid;
//     width:100%;
//     height:100%;
//     -webkit-transform: rotate(-90deg) scale(.68,.68);
//     -moz-transform:rotate(-90deg) scale(.58,.58);
//   }
// }
// `;

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function OutletTabs(props) {
  const [invoice, setinvoice] = useState(true);
  const [design, setdesign] = useState(false);
  const [unusedarea, setUnusedarea] = useState(true);
  const dispatch = useDispatch();
  const isVisible = usePageVisibility();
  const shopProfile = useSelector((state) => state.shopDetails);
  const [value, setValue] = useState(0);
  const [mode, setMode] = useState("add");
  const [PrinterType, setPrinterType] = useState("ImpactPrint");
  const [openModal, setOpenModal] = useState(false);
  // const [employee, setEmployee] = useState([]);
  const [outletArray, setOutletArray] = useState([]);
  const shopDetails = useSelector((state) => state.shopDetails);
  const [outlet, setOutlet] = useState({});
  const [rowsandcolumns, setRowsandcolumns] = "block";
  const [copies, setCopies] = useState("1");
  const [text, setText] = useState("123451234512");
  const debouncedSearchEanCode = useDebounce(text, 500);
  const [underline, setUnderline] = useState(false);
  const [fontstyle, setFontstyle] = useState(false);
  const [italic, setItalic] = useState("none");
  const [text2, setText2] = useState("500");
  const [barcode, setBarcode] = useState();
  const [type, setType] = useState("CODE128");
  const [textDecoration, setTextDecoration] = useState("none");
  const [sp, setSp] = React.useState("200");
  const [height, setHeight] = useState("20");
  const [font, setFont] = useState("monospace");
  const [color, setColor] = useState("#000000");
  const [width, setWidth] = useState("2");
  const [size, setSize] = useState("50");
  const [rect, isRect] = useState(false);
  const [oval, isOval] = useState(true);
  const [left1, setLeft1] = useState(20);
  const [right1, setRight1] = useState(10);
  const [single, isSingle] = useState(true);
  const [multiple, isMultiple] = useState(false);
  const [textAlign, setTextAlign] = useState("center");
  const [column, setColumn] = useState(3);
  const shopId = useSelector((state) => state.shopDetails.shopId);
  //const[top,setTop]=useState("-7")
  const classes = useStyles();
  const [center, setCenter] = useState("center");
  const [slide, setSlide] = useState("");
  const [array1, setArray1] = useState([]);
  const [array2, setArray2] = useState([]);
  const [isHovering, setIsHovering] = useState(false);
  const [color1, setColor1] = useState("#000000");
  const componentRef = React.useRef();
  const [word, setWord] = useState("Design page");
  const [spmodel, setSpmodel] = useState(false);
  const [spmodeltext, setSpmodeltext] = useState(true);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [barcodeshape, setBarcodeshape] = useState(false);
  const [borderradius, setBorderradius] = useState("30px");
  const [visible, setVisible] = useState("false");
  const [val, setVal] = useState("");
  const {
    token: { colorPrimary },
  } = theme.useToken();
  const productsForSearch = useSelector((state) => state.productsForSearch);
  const { productList: products } = useSelector((state) => state.products);
  const update = () => {
    alert("UpComing update");
  };
  const handleOnSearch = (v) => {
    setVal(v);
  };

  const shopname = shopProfile.shopName;
  // console.log("shopname", shopname, shopProfile);
  const [text1, setText1] = useState();
  const [rowdata, setRowdata] = useState(1);
  const [pagePerItem, setItemPerPage] = useState("single");
  //console.log("shopDetailssettings", shopDetails);
  const [mainUserShopDetails] = useLocalStorage("mainUserShopDetails", []);
  const location = useLocation();
  const [totalline, setTotalline] = useState("");
  const [fetchLoading, setFetchLoading] = useState(false);
  useEffect(
    () => {
      if (text === "TBD") {
        alert("Update the EAN code");
      } else if (debouncedSearchEanCode && text !== "") {
        const product = memorizedArray(text);
        if (product?.id) {
          getRelatedProducts(product.id, "fromScan");
        } else if (product === "Not Found") {
          // setItemNotFound(true);
        }
      }
    },
    [debouncedSearchEanCode, text] // Only call effect if debounced search term changes
  );

  const memorizedArray = (value) => {
    const cache = {};
    let result;

    if (cache[value] !== undefined) {
      result = cache[value];
    } else {
      const productValue = productsForSearch.find((i) => {
        return i?.eanCode?.toLowerCase() === value.toLowerCase();
      });
      if (productValue) {
        cache[value] = productValue;
        result = productValue;
      } else {
        result = "Not Found";
      }
    }
    return result;
  };

  useEffect(() => {
    (async function () {
      if (isVisible && shopDetails.shopId) {
        setFetchLoading(true);
        const shop_Details = await getShopDetails(shopDetails.shopId);
        const productDetails = await getProductDetails(shopDetails.shopId);
        //console.log("shop_Details", shop_Details);
        dispatch({
          type: "SET_SETTINGS",
          payload: shop_Details.settings,
        });
        if (productDetails.products) {
          const addToLocalStroage = productDetails?.products?.map((i) => {
            let label = i.productName;
            if (
              i.unitOfMeasurment !== "Others" &&
              i.unitOfMeasurment !== "" &&
              !i.unitOfMeasurment !== true
            ) {
              label = `${i.productName} (${i.unitOfMeasurment})`;
            }
            return {
              id: i.productId,
              name: label,
              eanCode: i.productEANCode,
              productCode: i.productCode,
              color: i.color,
              size: i.size,
              value: i.productName.toLowerCase(),
            };
          });
          dispatch({
            type: "SET_PRODUCTS_SEARCH",
            payload: addToLocalStroage,
          });
          dispatch({
            type: "SET_PRODUCT_LIST",
            payload: productDetails.products,
          });
        }
        setFetchLoading(false);
      }
    })();
  }, [isVisible, shopDetails.shopId]);
  const handleWidthChange = (event) => {
    const min = "1";
    const max = "5";
    const widthvalue = Math.max(min, Math.min(max, Number(event.target.value)));
    setWidth(widthvalue);
  };
  // useEffect(() => {
  //   const getProductDetails = async (shopId) => {
  //     await Promise.all([
  //       fetch(`${config.ApiGateway1}/getProductDetails`, {
  //         method: "POST",
  //         body: JSON.stringify({
  //           userId: shopId,
  //         }),
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }),
  //     ])
  //       .then(([res]) => Promise.all([res.json()]))
  //       .catch((err) => {
  //         console.log("Err", err);
  //       });
  //   };
  // }, []);
  const getRelatedProducts = (productId) => {
    const getProduct = products.find((i) => {
      return productId === i.productId;
    });
    console.log("product", getProduct);
    let barcodeValue = getProduct.productEANCode;
    let barcodeSp = getProduct.productPrice;
    let barcodeMrp = getProduct.productMrp;
    console.log("barcodeValue", barcodeValue);
    if (!getProduct.productEANCode) {
      alert("EAN code is empty");
      setText("1234");
    }
    setText(barcodeValue);
    setSp(barcodeSp);
    setText2(barcodeMrp);
    setText1(getProduct.productName);
    //addItemHandler(updateObj, "fromScan");
  };
  const handleOnSelect = (item) => {
    getRelatedProducts(item.id);
    //setVal("");
  };
  const formatResult = (item = {}) => {
    return (
      <div
        style={{
          padding: "1rem 0.75rem",
          borderBottom: "1px solid gray",
        }}
        key={item.value}
      >
        <span className="result-span">{item.name}</span>
      </div>
    );
  };
  const handleWidthChange1 = (event) => {
    const min = "1";
    const max = "3";
    const widthvalue = Math.max(min, Math.min(max, Number(event.target.value)));
    setWidth(widthvalue);
  };
  const handleNumberChange = (event) => {
    if (event.target.value.length > 12) {
      return false;
    }
    if (event.target.value.length <= 12) {
      setText(event.target.value);
    }
  };
  const ChangeCopies = (event) => {
    const min = "1";
    const max = "150";
    const copiesvalue = Math.max(
      min,
      Math.min(max, Number(event.target.value))
    );
    setCopies(copiesvalue);
  };
  const ChangesetRowdata = (event) => {
    const min = "1";
    const max = "150";
    const rowvalue = Math.max(min, Math.min(max, Number(event.target.value)));
    setRowdata(rowvalue);
  };
  const ChangeHeight = (event) => {
    const min = "1";
    const max = "300";
    const Sizevalue = Math.max(min, Math.min(max, Number(event.target.value)));
    setSize(Sizevalue);
  };
  const BarcodePrinterType = (Sizevalue) => {
    setPrinterType(Sizevalue);
  };
  useEffect(() => {
    if (PrinterType === "ImpactPrint") {
      setLeft1("30");
    }
    if (PrinterType === "TvsPrint") {
      setLeft1("38");
    }
  }, [PrinterType]);
  const BarcodeTypes = () => {
    var x = document.getElementById("BarcodeTypes");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  };
  const CODE128Type = () => {
    setType("CODE128");
    var x = document.getElementById("BarcodeTypes");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  };
  const CODE39Type = () => {
    setType("CODE39");
    var x = document.getElementById("BarcodeTypes");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  };
  const EAN13Type = () => {
    if (text.length < 12) {
      alert("Give 12 digit numbers");
    }
    setType("EAN13");
    var x = document.getElementById("BarcodeTypes");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  };
  const MSIType = () => {
    setType("MSI");
    var x = document.getElementById("BarcodeTypes");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  };
  const changeborder = () => {
    if (barcodeshape === false) {
      setBorderradius("0px");
      isOval(!oval);
      isRect(!rect);
      setBarcodeshape(true);
    } else {
      setBorderradius("30px");
      isRect(!rect);
      isOval(!oval);
      setBarcodeshape(false);
    }
  };
  const Stickersize = () => {
    var x = document.getElementById("sticker");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  };
  useEffect(() => {
    let numbers = [];
    let Numberofcopies = [];
    if (rowdata && column && copies) {
      //console.log(rowdata, column);
      let multipliedValue =
        parseFloat(rowdata) * parseFloat(column) * parseFloat(copies);
      //console.log("multipliedValue", multipliedValue);
      setTotalline(multipliedValue);
      for (var i = 1; i <= multipliedValue; i++) {
        numbers.push(i);
      }
      setArray1(numbers);
      //console.log(array1);
      for (var j = 1; j <= copies; j++) {
        Numberofcopies.push(j);
      }
      setArray2(Numberofcopies);
      console.log("array2", array2);
    }
  }, [rowdata, column, copies]);
  // var numbers = [];
  // for (var i = 1; i <= array1; i++) {
  //     numbers.push(i);
  // }
  console.log("location", props.location, location);
  const print = useReactToPrint({
    pageStyle: `
      @page {
        size: 25mm 35mm;
      }
    `,
    content: () => componentRef.current,
    documentTitle: "barcode-myshop",
    onBeforePrint: () => {
      if (copies === "") {
        alert("copies cannot be empty");
      }
      if (rowdata === "") {
        alert("Rows cannot be empty");
      }
    },
  });
  const handleMouseOver = () => {
    setIsHovering(true);
  };
  const singleBarcode = () => {
    setItemPerPage("multiple");
    isSingle(false);
    isMultiple(true);
    setWord("Design Page");
    setText("123456543");
    var x1 = document.getElementById("rowsandcolumns");
    if (x1.style.display === "block") {
      x1.style.display = "none";
    }
    // setColumn("3")
    setSize("250");
    setRowdata("1");
    setWidth(4);
    setHeight("28");
  };
  const multipleBarcode = () => {
    setItemPerPage("single");
    setWord("Preview Page");
    isSingle(true);
    var x1 = document.getElementById("rowsandcolumns");
    if (x1.style.display === "none") {
      x1.style.display = "block";
    }
    setSize("50");
    setText("123451234512");
    setWidth(2);
    isMultiple(false);
    setHeight("20");
  };
  const multipleBarcodeSticker = () => {
    setItemPerPage("single");
    var x = document.getElementById("sticker");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
    isSingle(true);
    var x1 = document.getElementById("rowsandcolumns");
    if (x1.style.display === "none") {
      x1.style.display = "block";
    }
    setSize("50");
    setText("123451234512");
    setWidth(2);
    isMultiple(false);
    setHeight("20");
  };
  const singleBarcodeSticker = () => {
    setItemPerPage("multiple");
    isSingle(false);
    isMultiple(true);
    var x1 = document.getElementById("rowsandcolumns");
    if (x1.style.display === "block") {
      x1.style.display = "none";
    }
    setWord("Design Page");
    setText("123456543");
    var x = document.getElementById("sticker");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
    // setColumn("3")
    setSize("250");
    setRowdata("1");
    setWidth(4);
    setHeight("28");
  };
  const AddSp = () => {
    setSpmodeltext(false);
    setSpmodel(true);
  };
  const AddSptick = () => {
    if (sp === "") {
      alert("selling price cannot be empty");
    }
    setSpmodeltext(true);
    setSpmodel(false);
  };
  // const employeeData = (employeeObj) => {
  //   if (employeeObj === undefined || employeeObj === null) return;
  //   if (Object.keys(employeeObj).length > 0) {
  //     var arr = Object.entries(employeeObj).map((data) => ({
  //       [data[0]]: data[1],
  //     }));
  //     setEmployee(arr);
  //   }
  // };
  const generateBarcode = () => {
    setBarcode(text);
  };

  function popupFunction() {
    setUnusedarea(!unusedarea);
    var popup = document.getElementById("myPopup");
    popup.classList.toggle("show");
  }
  //console.log("color1", color1);
  function closeNav() {
    document.getElementById("myNav").style.display = "none";
  }
  function changeStyle() {
    if (underline === false) {
      setTextDecoration("underline");
      setUnderline(true);
      console.log("underlinef", underline);
    }
    if (underline === true) {
      setTextDecoration("none");
      setUnderline(false);
      console.log("underlinet", underline);
    }
  }

  function changeStyle1() {
    if (fontstyle === false) {
      setItalic("italic");
      setFontstyle(true);
      console.log("underline", underline);
    }
    if (fontstyle === true) {
      setItalic("normal");
      setFontstyle(false);
    }
  }
  const reactToPrintContent = useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);
  const handleClick = () => {
    setOpenModal(true);
    setMode("add");
  };
  const cleardata = () => {
    setItemPerPage("single");
    isSingle(true);
    isMultiple(false);
    setItalic("normal");
    setCopies("1");
    setBorderradius("30px");
    setColor("#000000");
    setLeft1("30");
    setRight1("10");
    setText1(shopname);
    console.log("shopname1", shopname);
    var x1 = document.getElementById("rowsandcolumns");
    if (x1.style.display === "none") {
      x1.style.display = "block";
    }
    if (x1.style.display === "block") {
      x1.style.display = "block";
    }
    setText("123451234512");
    setColumn("3");
    setItemPerPage("single");
    setFont("monospace");
    setHeight("20");
    setItalic("none");
    setTextDecoration("none");
    setSize("50");
    setRowdata("1");
    setColor("black");
    setWidth(2);
    isRect(false);
    isOval(true);
    setBarcodeshape(false);
  };
  const handleEdit = (value) => {
    setOutlet(value);
    setOpenModal(true);
    setMode("edit");
  };
  const changeHandler2 = (colors) => {
    setColor1(colors.color);
    console.log(colors);
  };
  const handleClose = () => {
    setOpenModal(false);
  };

  const fetchOutlets = async (shopId) => {
    try {
      var res = await fetch(`${config.newApiGateway}/outlet/getOutlet`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "fetch",
          shopId: shopId,
        }),
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      dispatch({
        type: "SET_OUTLETS",
        payload: res.data,
      });
      setOutletArray(res.data);
    } catch (err) {
      console.log("Err", err);
    }
  };

  const addOutletHandler = async (values, mode) => {
    console.log("value", values, mode);
    var body = {};
    if (mode === "add") {
      body = {
        ...values,
        ownerShopId: shopProfile.shopId,
        type: "add",
      };
    } else {
      body = {
        ...values,
        userId: outlet.userId,
        type: "edit",
      };
    }
    try {
      var res = await fetch(`${config.newApiGateway}/outlet/getOutlet`, {
        method: "post",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
      fetchOutlets(shopProfile.shopId);
      setOpenModal(false);
    } catch (err) {
      console.log("Err", err);
    }
  };

  useEffect(() => {
    shopDetails.userType === "Shop" &&
      mainUserShopDetails.length === 0 &&
      fetchOutlets(shopDetails.shopId);
  }, [shopDetails.shopId, shopDetails.userType, mainUserShopDetails]);

  useEffect(() => {
    setValue(location.state || 0);
  }, [location.state]);

  useEffect(() => {
    setText1(shopProfile.shopName);
  }, [shopProfile.shopName]);

  return (
    <Card
      style={{
        marginTop: "20px",
      }}
    >
      <div
        value={value}
        index={3}
        style={{
          overflowX: "hidden",
          overflowY: "hidden",
        }}
      >
        <div
          className="column"
          style={{
            float: "left",
            width: "42%",
            borderRadius: "10px",
            padding: "0px 20px 0px 20px",
            overflowY: "scroll",
            height: "calc(100vh - 295px)",
            overflowX: "hidden",
            scrollSnapType: "y mandatory",
          }}
        >
          <Typography.Text
            style={{ padding: "20px 0px 10px 5px", fontWeight: 500 }}
          >
            Starting Point
            {/* <ReactToPrint
              pageStyle={pageStyle}
              trigger={() => {
                return (
                  <button>
                    Print
                  </button>  
                );
              }}
              content={reactToPrintContent}
            /> */}
          </Typography.Text>

          <div className="row">
            <div
              className="column"
              style={{
                float: "left",
                padding: "0px 15px 10px 15px",
              }}
            >
              <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                  <div>
                    <span>
                      <MdOutlineRadioButtonChecked
                        size={17}
                        color={colorPrimary}
                      />
                    </span>
                  </div>
                  <div style={{ display: "flex" }}>
                    <p style={{ padding: "0px 0px 0px 10px", display: "flex" }}>
                      Blank Template
                    </p>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    padding: "0px 0px 0px 60px",
                    cursor: "not-allowed",
                  }}
                >
                  <div>
                    <span>
                      <MdOutlineRadioButtonUnchecked
                        size={17}
                        color={colorPrimary}
                      />
                    </span>
                  </div>
                  <div>
                    <p style={{ padding: "0px 0px 0px 10px", display: "flex" }}>
                      Exisiting Document
                    </p>
                  </div>

                  <div
                    style={{ padding: "0px 0px 0px 20px", color: "#ABABAB" }}
                  >
                    <div
                      style={{
                        border: "1px solid lightgray",
                        borderRadius: "2px",
                        width: "35px",
                        padding: "0px 15px ",
                        fontSize: "10px",
                        padding: "1px",
                      }}
                    >
                      Select
                    </div>
                  </div>

                  {/* <Space><IoIosAddCircle style={{position:"relative",
          left:"18px",top:"5px",fontSize:"18px",
          backgroundColor:"white",borderRadius:"3px"}} /><HiOutlineDocument style={{fontSize:"27px"}}/></Space>
           
            <div style={{padding:"10px 10px 10px 10px",cursor: "not-allowed"}}>Blank Document
            </div> */}
                </div>
              </div>
            </div>
            <div className="dash1"></div>
            <div
              style={{
                padding: "20px",
              }}
            >
              <Typography.Text
                style={{
                  fontWeight: 500,
                  marginBottom: 20,
                }}
              >
                Printer Selection:{" "}
              </Typography.Text>
              <Select
                style={{
                  width: "200px",
                }}
                onChange={BarcodePrinterType}
                defaultValue={"ImpactPrint"}
              >
                <Select.Option value="ImpactPrint" selected>
                  Impact printer
                </Select.Option>
                <Select.Option value="TvsPrint">TVS printer</Select.Option>
              </Select>
            </div>
            <div className="dash1"></div>
            <div
              className="column"
              style={{
                float: "left",
                width: "50%",
                padding: "5px",
              }}
            >
              {/* <div 
          style={{
            padding:"1px 10px 2px 20px" ,
            width:"150",
            height:"42px",
            backgroundColor:"white",
            borderRadius: "3px",
            display:"flex"
            }}>
            <Space>
              <HiOutlineDocumentDuplicate 
              style={{
                fontSize:"25px",
                color: "#DBDBDB"
                }}/>
            </Space>
            <div style={{padding:"10px ",color: "#DBDBDB"}}>Existing Document</div>    
          </div> */}
            </div>
          </div>
          <Typography.Text style={{ padding: "10px 0px", fontWeight: 500 }}>
            Items Per Page
          </Typography.Text>
          <div style={{ display: "flex", padding: "0px 0px 20px 0px" }}>
            <div style={{ display: "flex" }}>
              <div style={{ padding: "1px" }}>
                <div onClick={singleBarcode}>
                  {multiple ? (
                    <span>
                      <MdOutlineRadioButtonChecked
                        color={colorPrimary}
                        size={17}
                      />
                    </span>
                  ) : (
                    <span>
                      <MdOutlineRadioButtonUnchecked
                        color={colorPrimary}
                        size={17}
                      />
                    </span>
                  )}
                </div>
                {/* <input 
            type="radio"
            name="radio-1" 
            onClick={()=> setItemPerPage("single")}
            checked={pagePerItem === "single"}
             /> */}
              </div>

              <div
                style={{
                  padding: "2px 10px 20px 5px",
                  fontFamily: "sans-serif",
                }}
              >
                Single Item per page
              </div>
            </div>
            <div style={{ padding: "0px 0px 0px 20px" }}>
              <div style={{ display: "flex" }}>
                <div style={{ padding: "1px" }}>
                  <div onClick={multipleBarcode}>
                    {single ? (
                      <span>
                        <MdOutlineRadioButtonChecked
                          color={colorPrimary}
                          size={17}
                        />
                      </span>
                    ) : (
                      <span>
                        <MdOutlineRadioButtonUnchecked
                          color={colorPrimary}
                          size={17}
                        />
                      </span>
                    )}
                  </div>
                </div>
                <label
                  for="mnc"
                  style={{
                    padding: "2px 10px 5px 5px",
                    fontFamily: "sans-serif",
                  }}
                >
                  Multiple Item per page
                </label>
              </div>
              <div id="rowsandcolumns" style={{ display: "block" }}>
                <div
                  style={{
                    color: "#ABABAB",
                    display: "flex",
                    padding: "0px 20px",
                  }}
                >
                  Columns:
                  <input
                    type="number"
                    //placeholder="2"
                    value={column}
                    //onChange={(e)=>setColumn(e.target.value)}
                    style={{
                      height: "17px",
                      width: "55px",
                      left: "555px",
                      top: "300px",
                      borderRadius: "3px",
                    }}
                  />
                </div>
                <div
                  style={{ color: "#ABABAB", padding: "5px 20px 10px 20px" }}
                >
                  Row
                  <span style={{ color: "white" }}>000</span> :
                  <input
                    type="number"
                    //placeholder="2"
                    value={rowdata}
                    id="numberarrow"
                    onChange={ChangesetRowdata}
                    style={{
                      height: "17px",
                      width: "55px",
                      left: "525px",
                      top: "330px",
                      borderRadius: "3px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="dash1"></div>
          <div
            style={{
              fontWeight: "500",
              fontSize: "15px",
              fontStyle: "normal",
              width: "137px",
              color: "#3F3F3F",
              paddingTop: 10,
            }}
          >
            Side Edges
          </div>
          <div
            style={{ display: "flex", padding: "0px 0px 20px 0px" }}
            className="popup"
          >
            <div style={{ padding: "10px" }} onClick={popupFunction}>
              {unusedarea ? (
                <span>
                  <MdOutlineRadioButtonChecked size={17} color={colorPrimary} />
                </span>
              ) : (
                <span>
                  <MdOutlineRadioButtonUnchecked
                    size={17}
                    color={colorPrimary}
                  />
                </span>
              )}
            </div>
            <div>
              <p
                style={{
                  padding: "10px 10px",
                }}
              >
                Change width of unused area
              </p>
            </div>
            <span className="popuptext" id="myPopup">
              <div>
                <div
                  style={{
                    display: "flex",
                    fontWeight: "300",
                    padding: "10px 30px",
                    fontFamily: "sans-serif",
                    fontSize: "13px",
                    color: "#363Cf4A",
                  }}
                >
                  Left{"   "}:
                  <div style={{ left: "120px" }}>
                    <input
                      type="number"
                      value={left1}
                      onChange={(e) => setLeft1(e.target.value)}
                      //placeholder="2"
                      style={{
                        height: "17px",
                        width: "55px",
                        left: "525px",
                        top: "370px",
                        borderRadius: "3px",
                        color: "#ABABAB",
                      }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    fontWeight: "300",
                    padding: "10px 30px",
                    fontFamily: "sans-serif",
                    fontSize: "13px",
                    color: "#363Cf4A",
                  }}
                >
                  Right:
                  <input
                    type="number"
                    //placeholder="2"
                    value={right1}
                    onChange={(e) => setRight1(e.target.value)}
                    style={{
                      height: "17px",
                      width: "55px",
                      left: "525px",
                      top: "370px",
                      borderRadius: "3px",
                      color: "#ABABAB",
                    }}
                  />
                </div>
              </div>
            </span>
          </div>

          <div>
            <div
              style={{
                textAlign: "right",
                backgroundColor: "#67748E",
                display: "flex",
              }}
            ></div>
            {/* <div style={{backgroundColor:"white",width:"17px",height:"479px",position:"absolute",top:"14.8%",right:"1.5%",border:"0.5px solid #D9D9D9",borderRadius:"0px 0px 0px 5px",}}>
          <div style={{position:"absolute",
            top:"250px",}}><BsArrowRightShort onClick={openNav}/></div>
          </div> */}
          </div>
          <div className="dash1"></div>
          <div
            style={{
              fontWeight: "500",
              padding: "10px 0px 5px 10px",
            }}
          >
            Shape
          </div>
          <div style={{ display: "flex", padding: "10px 10px 30px 10px" }}>
            <div style={{ padding: "0px 10px 0px 0px" }}>
              <div onClick={changeborder}>
                {rect ? (
                  <span>
                    <MdOutlineRadioButtonChecked
                      color={colorPrimary}
                      size={17}
                    />
                  </span>
                ) : (
                  <span>
                    <MdOutlineRadioButtonUnchecked
                      color={colorPrimary}
                      size={17}
                    />
                  </span>
                )}
              </div>
              {/* <input 
            type="radio"
            name="radio-2" 
            onClick={shape}
          /> */}
            </div>
            <div
              style={{
                padding: "0px 10px",
              }}
            >
              Rectangle
            </div>
            <div style={{ padding: "0px 0px 0px 40px", display: "flex" }}>
              <div onClick={changeborder}>
                {oval ? (
                  <span>
                    <MdOutlineRadioButtonChecked
                      color={colorPrimary}
                      size={17}
                    />
                  </span>
                ) : (
                  <span>
                    <MdOutlineRadioButtonUnchecked
                      color={colorPrimary}
                      size={17}
                    />
                  </span>
                )}
              </div>
              {/* <input 
            type="radio"
            name="radio-2"
            checked="checked"
            onClick={shape1} 
             /> */}
              <div
                style={{
                  padding: "0px 10px",
                }}
              >
                Rounded Rectangle
              </div>
            </div>
          </div>
          <div className="dash1"></div>
          <div style={{ padding: "20px 20px 20px 10px" }}>
            <div
              style={{
                fontWeight: "500",
                fontSize: "15px",
                width: "137px",
                color: "#3F3F3F",
              }}
            >
              Template Size
            </div>
            {/* <h6 >Template Size</h6> */}
            <div style={{ padding: "10px 5px 5px 5px" }}>
              <div
                style={{
                  display: "flex",
                  border: "1.5px solid #D9D9D9",
                  position: "relative",
                  height: "30px",
                }}
                onClick={Stickersize}
              >
                <p style={{ padding: "5px 0px 0px 10px" }}>New sticker size </p>
                <div style={{ padding: "5px 0px 5px 0px" }}>
                  <RiArrowDownSLine
                    size={18}
                    style={{
                      transform: "scaleX(1.5)",
                      marginLeft: "10px",
                      position: "absolute",
                      right: "10%",
                    }}
                  />
                </div>
              </div>
              <div
                id="sticker"
                style={{ display: "none", border: "1.5px solid #D9D9D9" }}
              >
                <div
                  className="multipleBarcodeSticker"
                  onClick={multipleBarcodeSticker}
                >
                  New Sticker 35mmx25mm
                </div>
                <div
                  className="singleBarcodeSticker"
                  onClick={singleBarcodeSticker}
                >
                  New Sticker 105mmx75mm
                </div>
              </div>
              {/* <select 
        style={{width:"300px",
        borderRadius:"2px",
        padding:"5px "}}
      
        >
          <option disabled selected hidden >New Sticker{width}X{size}</option>
          <option onClick={multipleBarcode} value="New Sticker 35mmx25mm">New Sticker 35mmx25mm</option>
          <option onClick={singleBarcode} value="New Sticker 105mmx75mm">New Sticker 105mmx75mm</option>
        </select> */}
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div style={{ display: "flex", padding: "10px 25px 20px 25px" }}>
              <div
                style={{
                  height: "20px",
                  width: "39px",
                  left: "542px",
                  top: "203.38720703125px",
                  borderRadius: "nullpx",
                }}
              >
                width{"  "}
              </div>
              {pagePerItem === "multiple" && (
                <input
                  type="number"
                  value={width}
                  id="numberarrow"
                  onChange={handleWidthChange}
                  style={{
                    height: "20px",
                    width: "70px",
                    left: "580px",
                    top: "202px",
                    borderRadius: "3px",
                  }}
                />
              )}
              {pagePerItem === "single" && (
                <input
                  type="number"
                  value={width}
                  id="numberarrow"
                  onChange={handleWidthChange1}
                  style={{
                    height: "20px",
                    width: "70px",
                    left: "580px",
                    top: "202px",
                    borderRadius: "3px",
                  }}
                />
              )}

              {/* <select onChange={(e)=>setWidth(e.target.value)} style={{
           width: "76px",
           color:"#344054",
           fontSize:"14px",fontFamily:"Inter"}}>
          <option value="1" >1</option>
          <option value="2" selected>2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
        </select> */}
            </div>
            <div style={{ display: "flex", padding: "10px" }}>
              <div
                style={{
                  height: "20px",
                  width: "45px",
                  left: "542px",
                  top: "230px",
                  borderRadius: "nullpx",
                }}
              >
                Height
              </div>
              <input
                type="number"
                value={size}
                id="numberarrow"
                //placeholder="100"
                onChange={ChangeHeight}
                style={{
                  height: "20px",
                  width: "70px",
                  left: "580px",
                  top: "230px",
                  borderRadius: "3px",
                }}
              />
            </div>
          </div>
          <div className="dash1"></div>
          {/* <Select
        className='fas'
        value={type}
        placeholder="&#xf02a;"
        onChange={handleChangetype}
        options={websiteFilterFiedsOptions}
        /> */}
          <div
            style={{
              fontWeight: "500",
              fontSize: "15px",
              fontFamily: "Rubik",
              fontStyle: "normal",
              lineHeight: "40px",
              color: "#3F3F3F",
              padding: "10px",
            }}
          >
            No Of Copies To Print
          </div>
          {/* <p style={{padding:"10px 20px"}}>No Of Copies To Print</p>  */}
          <div style={{ padding: " 0px 20px 0px 20px" }}>
            <input
              type="number"
              value={copies}
              className="numberarrow"
              id="numberarrow"
              style={{ width: "65px", height: "20px" }}
              onChange={ChangeCopies}
            />
          </div>
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button type="primary" ghost onClick={cleardata}>
              Clear
            </Button>
            <Button
              style={{
                marginLeft: 8,
              }}
              onClick={print}
              type="primary"
            >
              Print
            </Button>
          </div>
        </div>
        <div
          className="column"
          style={{
            float: "left",
            width: "57%",
            background: "white",
            borderRadius: "10px",
            padding: "0px 0px 0px 2px",
            overflowX: "hidden",
            position: "relative",
            overflowY: "auto",
            height: "calc(100vh - 304px)",
          }}
        >
          <div>
            <div
            // style={{
            //   display: "flex",
            // }}
            >
              <div style={{ display: "flex" }}>
                <div className="animate-charcter">
                  <h5
                    style={{
                      padding: "40px 0px 10px 20px",
                    }}
                  >
                    Template Design
                  </h5>
                </div>
                <div
                  style={{
                    width: "200px",
                    marginTop: "35px",
                    marginLeft: "10px",
                    position: "absolute",
                    left: "30%",
                  }}
                >
                  <ReactSearchAutocomplete
                    placeholder="Search items"
                    items={productsForSearch}
                    onSelect={handleOnSelect}
                    onSearch={handleOnSearch}
                    styling={{
                      borderRadius: 4,
                      boxShadow: "none",
                      zIndex: 100,
                    }}
                    formatResult={formatResult}
                    inputSearchString={val}
                    fuseOptions={{
                      shouldSort: true,
                      threshold: 0.6,
                      location: 0,
                      distance: 75,
                      minMatchCharLength: 1,
                      keys: ["name"],
                      includeMatches: false,
                    }}
                  />
                </div>
                <div style={{ position: "absolute", right: "7%" }}>
                  {spmodeltext && (
                    <div
                      onClick={AddSp}
                      style={{
                        padding: "10px 0px 0px 20px",
                        color: "tomato",
                        cursor: "pointer",
                      }}
                    >
                      Add selling price
                    </div>
                  )}
                  {spmodel && (
                    <div
                      style={{
                        padding: "10px 0px 0px 20px",
                        display: "flex",
                      }}
                    >
                      <input
                        value={sp}
                        type="number"
                        onChange={(e) => setSp(e.target.value)}
                        style={{
                          width: "50px",
                          height: "20px",
                          borderRadius: "2px",
                        }}
                      />
                      <div
                        onClick={AddSptick}
                        style={{ cursor: "pointer", color: "tomato" }}
                      >
                        ✓
                      </div>
                    </div>
                  )}

                  {pagePerItem === "multiple" && (
                    <div
                      style={{
                        padding: "10px 0px 10px 20px",
                      }}
                    >
                      width{"         "}
                      <input
                        type="range"
                        min="1"
                        max="5"
                        className="sliderwidth"
                        value={width}
                        id="myRange"
                        onChange={(e) => setWidth(e.target.value)}
                      />
                    </div>
                  )}
                  {pagePerItem === "single" && (
                    <div
                      style={{
                        padding: "10px 0px 10px 10px",
                      }}
                    >
                      width{"         "}
                      <input
                        type="range"
                        min="1"
                        max="3"
                        className="sliderwidth"
                        value={width}
                        id="myRange"
                        onChange={(e) => setWidth(e.target.value)}
                      />
                    </div>
                  )}
                </div>
                {/* <div>
                <h4
                style={{
                  padding: "20px 0px 10px 20px",
                }}
              >
                Template Design
              </h4>
              
                </div>
                */}
                {/* <div >
              {pagePerItem === "multiple" && (
                <div
                  style={{
                    padding: "20px 0px 10px 150px",
                  }}
                >
                  width{"         "}
                  <input
                    type="range"
                    min="1"
                    max="5"
                    className="sliderwidth"
                    value={width}
                    id="myRange"
                    onChange={(e) => setWidth(e.target.value)}
                  />
                </div>
              )}
              {pagePerItem === "single" && (
                <div
                  style={{
                    padding: "20px 0px 10px 150px",
                  }}
                >
                  width{"         "}
                  <input
                    type="range"
                    min="1"
                    max="3"
                    className="sliderwidth"
                    value={width}
                    id="myRange"
                    onChange={(e) => setWidth(e.target.value)}
                  />
                </div>
              )}
              </div> */}
              </div>

              {/* <div style={{margin:"20px 0px 0px 10px", width:"200px",display:"flex"}}>
              <div>
              <h5
                style={{
                  padding: "20px 0px 10px 20px",
                }}
              >
                Template Design
              </h5>
              </div>
              
              <ReactSearchAutocomplete
               placeholder="Search items"
               items={productsForSearch}
               onSelect={handleOnSelect}
               onSearch={handleOnSearch}
               styling={{
                 borderRadius: 4,
                 boxShadow: "none",
                 zIndex: 100,
                
               }}
               formatResult={formatResult}
               inputSearchString={val}
               fuseOptions={{
                shouldSort: true,
                threshold: 0.6,
                location: 0,
                distance: 75,
                minMatchCharLength: 1,
                keys: ["name", "productCode"],
                includeMatches: false,
              }}
              />
              </div>
                   */}
              {/* <h4
                style={{
                  padding: "20px 0px 10px 20px",
                }}
              >
                Template Design
              </h4>
              <div style={{paddingLeft:"20px",paddingTop:"10px"}}>
              </div>  
              {pagePerItem === "multiple" && (
                <div
                  style={{
                    padding: "30px 0px 10px 20px",
                  }}
                >
                  width{"         "}
                  <input
                    type="range"
                    min="1"
                    max="5"
                    className="sliderwidth"
                    value={width}
                    id="myRange"
                    onChange={(e) => setWidth(e.target.value)}
                  />
                </div>
              )}
              {pagePerItem === "single" && (
                <div
                  style={{
                    padding: "30px 0px 10px 70px",
                  }}
                >
                  width{"         "}
                  <input
                    type="range"
                    min="1"
                    max="3"
                    className="sliderwidth"
                    value={width}
                    id="myRange"
                    onChange={(e) => setWidth(e.target.value)}
                  />
                </div>
              )} */}
            </div>

            <div className="overlay-content">
              <TextField
                value={text}
                id="scanItem"
                placeholder="Barcode Number"
                onChange={handleNumberChange}
                variant="outlined"
                type="number"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <QrCodeScannerIcon size={10} />
                    </InputAdornment>
                  ),
                }}
                style={{
                  width: "20%",
                  position: "absolute",
                  left: "5%",
                  top: "-10px",
                  // border: "1.5px solid #D9D9D9",
                  borderRadius: "20px",
                  padding: "2px",
                  fontSize: "14px",
                }}
              />
              <input
                value={text1}
                placeholder="Shop Name"
                onChange={(e) => setText1(e.target.value)}
                style={{
                  width: "20%",
                  position: "absolute",
                  left: "48%",
                  top: "-10px",
                  border: "1.5px solid #D9D9D9",
                  borderRadius: "10px",
                  padding: "6px",
                  fontSize: "14px",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  right: "5%",
                  top: "-10px",
                  border: "1.5px solid #D9D9D9",
                  borderRadius: "10px",
                  color: "#344054",
                  fontFamily: "Inter",
                  padding: "3px 14px",
                  fontSize: "22px",
                }}
                onClick={changeStyle1}
              >
                <AiOutlineItalic />
              </div>
              <div
                style={{
                  position: "absolute",
                  left: "27%",
                  top: "-10px",
                  fontSize: "14px",
                  width: "20%",
                }}
              >
                <select
                  onChange={(e) => setFont(e.target.value)}
                  style={{
                    border: "1.5px solid #D9D9D9",
                    borderRadius: "10px",
                    color: "#344054",
                    fontFamily: "Inter",
                    padding: "10px",
                    fontSize: "14px",
                  }}
                >
                  <option value="Monospace">Monospace</option>
                  <option value="Cursive">Cursive</option>
                  <option value="Serif">Serif</option>
                  <option value="Helvetica">Helvetica</option>
                  <option value="fantasy">fantasy</option>
                </select>
              </div>
              <div style={{ display: "flex" }}>
                <div
                  onClick={BarcodeTypes}
                  style={{
                    position: "absolute",
                    left: "70%",
                    top: "-10px",
                    display: "flex",
                    border: "1.5px solid #D9D9D9",
                    borderRadius: "10px",
                    padding: "3px",
                    width: "15%",
                  }}
                >
                  <div>
                    <RiBarcodeLine
                      size={28}
                      style={{
                        transform: "scaleX(2)",
                        padding: "0px 0px 0px 10px",
                      }}
                    />
                  </div>
                  <div>
                    <RiArrowDownSLine
                      size={20}
                      style={{
                        transform: "scaleX(1.5)",
                        marginLeft: "10px",
                        padding: "10px 0px 0px 10px",
                      }}
                    />
                  </div>
                </div>
                <div
                  id="BarcodeTypes"
                  style={{
                    position: "absolute",
                    left: "405px",
                    top: "-100px",
                    width: "75px",
                    backgroundColor: "white",
                    border: "1px solid #e5e2f2",
                    height: "85px",
                    display: "none",
                  }}
                >
                  <div
                    onClick={CODE128Type}
                    className="CODE128Type"
                    style={{ cursor: "pointer" }}
                  >
                    CODE128
                  </div>
                  <div
                    onClick={CODE39Type}
                    className="CODE39Type"
                    style={{ cursor: "pointer" }}
                  >
                    Code39
                  </div>
                  <div
                    onClick={MSIType}
                    className="MSIType"
                    style={{ cursor: "pointer" }}
                  >
                    MSI
                  </div>
                  <div
                    onClick={EAN13Type}
                    className="EAN13Type"
                    style={{ cursor: "pointer" }}
                  >
                    EAN13
                  </div>
                </div>
                <div style={{ position: "absolute", right: "5%", top: "45px" }}>
                  {pagePerItem === "multiple" && (
                    <select
                      onChange={(e) => setHeight(e.target.value)}
                      style={{
                        border: "1.5px solid #D9D9D9",
                        borderRadius: "10px",
                        padding: "8px 5px",
                        color: "#344054",
                        fontSize: "14px",
                        fontFamily: "Inter",
                      }}
                    >
                      {/* <option value="200" >125</option> */}
                      <option value="16">16</option>
                      <option value="18">18</option>
                      <option value="20">20</option>
                      <option value="22">22</option>
                      <option value="24">24</option>
                      <option value="26">26</option>
                      <option value="28" selected>
                        28
                      </option>
                      <option value="30">30</option>
                      <option value="34">34</option>
                    </select>
                  )}
                  {pagePerItem === "single" && (
                    <select
                      onChange={(e) => setHeight(e.target.value)}
                      style={{
                        border: "1.5px solid #D9D9D9",
                        borderRadius: "10px",
                        padding: "8px 5px",
                        color: "#344054",
                        fontSize: "14px",
                        fontFamily: "Inter",
                      }}
                    >
                      {/* <option value="200" >125</option> */}
                      <option value="10">10</option>
                      <option value="12">12</option>
                      <option value="14">14</option>
                      <option value="16">16</option>
                      <option value="18">18</option>
                      <option value="20">20</option>
                      <option value="22">22</option>
                      <option value="24" selected>
                        24
                      </option>
                      {/* <option value="19" >
                        19
                      </option> */}
                      <option value="26">26</option>
                      <option value="28">28</option>
                      <option value="30">30</option>
                      <option value="32">32</option>
                    </select>
                  )}
                </div>
                <div
                  style={{
                    position: "absolute",
                    right: "5%",
                    top: "100px",
                    border: "1.5px solid #D9D9D9",
                    borderRadius: "10px",
                    color: "#344054",
                    fontFamily: "Inter",
                    padding: "5px 3px",
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <AiOutlineBgColors
                      color={color}
                      style={{
                        fontSize: "16px",
                      }}
                    />
                    <div style={{ padding: "0px 3px" }}>
                      <ColorPicker
                        color={"#0000"}
                        alpha={30}
                        onChange={changeHandler2}
                        placement="topLeft"
                        className="some-class"
                        enableAlpha={false}
                      >
                        <button className="rc-color-picker-trigger"></button>
                      </ColorPicker>
                    </div>
                  </div>
                </div>
              </div>

              <input
                value={text2}
                placeholder="MRP:"
                onChange={(e) => setText2(e.target.value)}
                style={{
                  width: "50px",
                  position: "absolute",
                  right: "5%",
                  top: "150px",
                  border: "1.5px solid #D9D9D9",
                  borderRadius: "10px",
                  padding: "7px",
                  fontSize: "14px",
                }}
                type="number"
              />
              <div
                style={{
                  padding: "0px 30px 5px 10px",
                  position: "absolute",
                  right: "5%",
                  top: "0px",
                }}
              >
                <div>
                  <div
                    style={{
                      position: "absolute",
                      right: "5%",
                      top: "200px",
                      color: "#344054",
                      fontFamily: "Inter",
                      fontSize: "30px",
                      border: "1.5px solid #D9D9D9",
                      borderRadius: "10px",
                      padding: "5px 10px 80px 10px",
                      cursor: "pointer",
                    }}
                  >
                    <GrTextAlignCenter onClick={() => setCenter("center")} />
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      right: "7%",
                      top: "240px",
                      color: "#344054",
                      fontFamily: "Inter",
                      fontSize: "30px",
                      cursor: "pointer",
                    }}
                  >
                    <GrTextAlignRight onClick={() => setCenter("right")} />
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      right: "7%",
                      top: "280px",
                      color: "#344054",
                      fontFamily: "Inter",
                      fontSize: "30px",
                      cursor: "pointer",
                    }}
                  >
                    <GrTextAlignLeft onClick={() => setCenter("left")} />
                  </div>
                </div>
              </div>
              <div
                style={{
                  paddingRight: "33px",
                  position: "absolute",
                  right: "0%",
                  top: "315px",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    right: "30px",
                    top: "20px",
                    border: "1.5px solid #D9D9D9",
                    borderRadius: "10px",
                    color: "#344054",
                    fontFamily: "Inter",
                    padding: "0px 7px",
                    fontSize: "28px",
                  }}
                  onClick={changeStyle}
                >
                  <AiOutlineUnderline />
                </div>
              </div>

              <div
                className="barcodecontainer"
                style={{
                  backgroundColor: "#EDF3FF",
                  width: "79%",
                  height: window.screen.height / 2.8,
                  top: "40px",
                  left: "5%",
                  position: "absolute",
                  border: "2px #D9D9D9",
                  overflow: "scroll",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    left: "0",
                    top: "55px",
                    // backgroundColor:"white",
                    borderRadius: "15px",
                    // width:"250px"
                  }}
                >
                  {pagePerItem === "single" && (
                    <div
                      style={{
                        position: "absolute",
                        left: "35%",
                        top: "15%",
                        margin: "20%",
                      }}
                    >
                      <div
                        id="single"
                        style={{
                          padding: `0px ${right1}px 10px ${left1}px`,
                          marginLeft: "32%",

                          borderRadius: `${borderradius}`,
                          width: "280px",
                          height: "200px",
                          padding: `30px ${right1}px 10px ${left1}px`,
                          //WebkitTransform:"rotate(90deg)",
                          transform: "scale(1.2)",
                          backgroundColor: "white",
                          fontFamily: `${font}`,
                        }}
                      >
                        <div
                          style={{
                            fontFamily: `${font}`,
                            padding: "2px",
                            textAlign: "center",
                            fontSize: `${height}px`,
                            fontWeight: "900",
                            textDecoration: `${textDecoration}`,
                            fontStyle: `${italic}`,
                            color: "#000",
                          }}
                          id="title"
                        >
                          <bold>{text1}</bold>
                        </div>
                        <Barcode
                          value={text}
                          style={{ width: "250px", transform: "scale(0.4)" }}
                          id="barcode"
                          format={type}
                          fontSize="20"
                          font={font}
                          lineColor={color1}
                          textAlign={center}
                          width={width}
                          height={size}
                        />
                        <div style={{ display: "flex" }}>
                          <div
                            style={{
                              fontFamily: `${font}`,
                              fontSize: `${height}px`,
                              fontWeight: "900",
                              textAlign: "left",
                              paddingLeft: "20px",
                              color: "#000",
                            }}
                          >
                            <strong>SP:{sp}</strong>
                          </div>
                          <div
                            style={{
                              fontFamily: `${font}`,
                              fontSize: `${height}px`,
                              fontWeight: "900",
                              textAlign: "right",
                              paddingLeft: "70px",
                              color: "#000",
                            }}
                          >
                            <strong>MRP:{text2}</strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {
                    //this for single barcode design page
                    pagePerItem === "multiple" && (
                      <div>
                        <div
                          id="single"
                          style={{
                            padding: `0px ${right1}px 10px ${left1}px`,
                            marginLeft: "-70px",
                            marginTop: "-110px",
                            borderRadius: `${borderradius}`,
                            width: "600px",
                            height: "470px",
                            padding: `30px ${right1}px 10px ${left1}px`,
                            //WebkitTransform:"rotate(90deg)",
                            transform: "scale(0.5)",
                            backgroundColor: "white",
                            fontFamily: `${font}`,
                          }}
                        >
                          <div
                            id="single"
                            style={{
                              padding: `0px ${right1}px 10px ${left1}px`,
                              marginLeft: "-30px",
                              // marginTop: "-130px",
                              borderRadius: `${borderradius}`,
                              width: "600px",
                              // height: "470px",
                              padding: `30px ${right1}px 10px ${left1}px`,
                              //WebkitTransform:"rotate(90deg)",
                              // transform: "scale(0.5)",
                              backgroundColor: "white",
                              fontFamily: `${font}`,
                              padding: "2px",
                              textAlign: "center",
                              fontSize: `${height}px`,
                              textDecoration: `${textDecoration}`,
                              fontStyle: `${italic}`,
                              color: "#000",
                            }}
                          >
                            <bold>{text1}</bold>
                            <Barcode
                              value={text}
                              style={{
                                width: "250px",
                                transform: "scale(0.4)",
                              }}
                              id="barcode"
                              format={type}
                              fontSize={height}
                              font={font}
                              lineColor={color1}
                              textAlign={center}
                              width={width}
                              height={size}
                            />
                            <div style={{ display: "flex" }}>
                              <div
                                style={{
                                  fontFamily: `${font}`,
                                  fontSize: `${height}px`,
                                  fontWeight: "900",
                                  textAlign: "left",
                                  paddingLeft: "80px",
                                  color: "#000",
                                }}
                              >
                                <strong>SP:{sp}</strong>
                              </div>
                              <div
                                style={{
                                  fontFamily: `${font}`,
                                  fontSize: `${height}px`,
                                  fontWeight: "900",
                                  textAlign: "right",
                                  paddingLeft: "150px",
                                  color: "#000",
                                }}
                              >
                                <strong>MRP:{text2}</strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                  <div></div>
                  <div
                    style={{
                      position: "absolute",
                      //float:"left"
                      left: "-30px",
                      top: "-30px",
                    }}
                    id="printablediv"
                    className="page-break"
                    ref={componentRef}
                  >
                    {/* <style type="text/css" media="print">{"\
@page {\ size: 25mm 105mm ;}\
"}</style> */}

                    {pagePerItem === "multiple" &&
                      PrinterType === "ImpactPrint" && (
                        <div>
                          {array2.map((array, index) => (
                            <div
                              id="single"
                              key={index}
                              style={{
                                padding: `0px ${right1}px 10px ${left1}px`,
                                borderRadius: `${borderradius}`,
                                transform: "scale(0.8)",
                                gridTemplateColumns: `repeat(${1},auto)`,
                                //WebkitTransform:"rotate(90deg)",
                                //position:"absolute",
                                // right:0,
                                width: "600px",
                                height: "560px",
                                backgroundColor: "white",
                                fontFamily: `${font}`,
                              }}
                            >
                              <div
                                id="single"
                                key={index}
                                style={{
                                  padding: `0px ${right1}px 10px ${left1}px`,
                                  borderRadius: `${borderradius}`,
                                  transform: "scale(0.8)",
                                  gridTemplateColumns: `repeat(${1},auto)`,
                                  //WebkitTransform:"rotate(90deg)",
                                  //position:"absolute",
                                  // right:0,
                                  width: "600px",
                                  height: "560px",
                                  backgroundColor: "white",
                                  fontFamily: `${font}`,
                                }}
                              >
                                <div
                                  style={{
                                    fontFamily: `${font}`,
                                    padding: "20px",
                                    textAlign: "center",
                                    fontSize: `${height}px`,
                                    fontWeight: "900",
                                    textDecoration: `${textDecoration}`,
                                    fontStyle: `${italic}`,
                                    color: "#000",
                                  }}
                                  id="title"
                                >
                                  {text1}
                                </div>
                                <Barcode
                                  value={text}
                                  id="barcode"
                                  format={type}
                                  fontSize={height}
                                  font={font}
                                  lineColor={color1}
                                  textAlign={center}
                                  width={width}
                                  height={size}
                                />
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{
                                      fontFamily: `${font}`,
                                      fontSize: `${height}px`,
                                      fontWeight: "900",
                                      textAlign: "left",
                                      paddingLeft: "40px",
                                      color: "#000",
                                    }}
                                  >
                                    <strong>SP:{sp}</strong>
                                  </div>
                                  <div
                                    style={{
                                      fontFamily: `${font}`,
                                      fontSize: `${height}px`,
                                      fontWeight: "900",
                                      textAlign: "right",
                                      paddingLeft: "170px",
                                      color: "#000",
                                    }}
                                  >
                                    <strong>MRP:{text2}</strong>
                                  </div>
                                </div>
                              </div>
                              <Barcode
                                value={text}
                                id="barcode"
                                format={type}
                                fontSize={height}
                                font={font}
                                lineColor={color1}
                                textAlign={center}
                                width={width}
                                height={size}
                              />
                              <div style={{ display: "flex" }}>
                                <div
                                  style={{
                                    fontFamily: `${font}`,
                                    fontSize: `${height}px`,
                                    fontWeight: "900",
                                    textAlign: "left",
                                    paddingLeft: "40px",
                                    color: "#000",
                                  }}
                                >
                                  <strong>SP:{sp}</strong>
                                </div>
                                <div
                                  style={{
                                    fontFamily: `${font}`,
                                    fontSize: `${height}px`,
                                    fontWeight: "900",
                                    textAlign: "right",
                                    paddingLeft: "170px",
                                    color: "#000",
                                  }}
                                >
                                  <strong>MRP:{text2}</strong>
                                </div>
                              </div>
                            </div>
                          ))}
                          <br />
                        </div>
                      )}
                    {pagePerItem === "multiple" &&
                      PrinterType === "TvsPrint" && (
                        <div>
                          {array2.map((array, index) => (
                            <div
                              id="single"
                              key={index}
                              style={{
                                padding: `0px ${right1}px 10px ${left1}px`,
                                borderRadius: `${borderradius}`,
                                transform: "scale(0.8)",
                                gridTemplateColumns: `repeat(${1},auto)`,
                                //WebkitTransform:"rotate(90deg)",
                                //position:"absolute",
                                // right:0,
                                width: "600px",
                                height: "560px",
                                backgroundColor: "white",
                                fontFamily: `${font}`,
                              }}
                            >
                              <div
                                style={{
                                  fontFamily: `${font}`,
                                  padding: "20px",
                                  textAlign: "center",
                                  fontSize: `${height}px`,
                                  fontWeight: "900",
                                  textDecoration: `${textDecoration}`,
                                  fontStyle: `${italic}`,
                                  color: "#000",
                                }}
                                id="title"
                              >
                                {text1}
                              </div>
                              <Barcode
                                value={text}
                                id="barcode"
                                format={type}
                                fontSize={height}
                                font={font}
                                lineColor={color1}
                                textAlign={center}
                                width={width}
                                height={size}
                              />
                              <div style={{ display: "flex" }}>
                                <div
                                  style={{
                                    fontFamily: `${font}`,
                                    fontSize: `${height}px`,
                                    fontWeight: "900",
                                    textAlign: "left",
                                    color: "#000",
                                    paddingLeft: "40px",
                                  }}
                                >
                                  <strong>SP:{sp}</strong>
                                </div>
                                <div
                                  style={{
                                    fontFamily: `${font}`,
                                    fontSize: `${height}px`,
                                    fontWeight: "900",
                                    textAlign: "right",
                                    paddingLeft: "170px",
                                    color: "#000",
                                  }}
                                >
                                  <strong>MRP:{text2}</strong>
                                </div>
                              </div>
                              {/* <div
                              style={{
                                fontFamily: `${font}`,
                                fontSize: `${height}px`,
                                padding: "5px 10px",
                                textAlign: "right",
                              }}
                            >
                              <strong>MRP:{text2}</strong>
                            </div> */}
                            </div>
                          ))}

                          <br />
                        </div>
                      )}
                    {pagePerItem === "single" && PrinterType === "TvsPrint" && (
                      <div
                        id="multiple"
                        className="parent"
                        style={{
                          display: "grid",
                          gridTemplateColumns: `repeat(${3},auto)`,
                          //gridTemplateColumns: `repeat(${column},auto-fill, minmax(100px, 1fr))`,
                          //gridGap: "10px",
                          //marginRight: "auto",
                          transform: "scale(0.75)",
                          //WebkitTransform:"rotate(90deg)",
                          position: "absolute",
                          left: 18,
                          top: 10,
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        {array1.map((array, index) => (
                          <div>
                            <div
                              className="each-slide"
                              key={index}
                              style={{
                                padding: `35px ${right1}px 10px ${left1}px`,
                                borderRadius: `${borderradius}`,
                                backgroundColor: "white",
                                width: "250px",
                                height: "200px",
                                // transform: "scale(0.9)",
                              }}
                            >
                              <div
                                style={{
                                  fontFamily: `${font}`,
                                  fontSize: `${height}px`,
                                  padding: "10px 0px 0px 30px",
                                  textDecoration: `${textDecoration}`,
                                  fontWeight: "900",
                                  color: "#000",
                                  fontStyle: `${italic}`,
                                }}
                                id="title"
                              >
                                {text1}
                              </div>
                              <Barcode
                                value={text}
                                id="barcode"
                                format={type}
                                fontSize={20}
                                font={font}
                                margin={5}
                                lineColor={color1}
                                textAlign={center}
                                width={width}
                                height={size}
                              />

                              <div style={{ display: "flex" }}>
                                <div
                                  style={{
                                    fontFamily: `${font}`,
                                    fontSize: `${height}px`,
                                    fontWeight: "900",
                                    textAlign: "left",
                                    color: "#000",
                                    paddingLeft: "20px",
                                  }}
                                >
                                  <strong>SP:{sp}</strong>
                                </div>
                                <div
                                  style={{
                                    fontFamily: `${font}`,
                                    fontSize: `${height}px`,
                                    fontWeight: "900",
                                    textAlign: "right",
                                    color: "#000",
                                    paddingLeft: "70px",
                                  }}
                                >
                                  <strong>MRP:{text2}</strong>
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                padding: `30px ${right1}px 10px ${left1}px`,
                                borderRadius: `${borderradius}`,
                                backgroundColor: "white",
                                width: "280px",
                                height: "150px",
                              }}
                            ></div>
                            <div
                              style={{
                                padding: `30px ${right1}px 10px ${left1}px`,
                                borderRadius: `${borderradius}`,
                                backgroundColor: "white",
                                width: "280px",
                                height: "250px",
                              }}
                            ></div>
                            <br />
                          </div>
                        ))}
                      </div>
                    )}
                    {pagePerItem === "single" &&
                      PrinterType === "ImpactPrint" && (
                        <div
                          id="multiple"
                          className="parent"
                          style={{
                            display: "grid",
                            gridTemplateColumns: `repeat(${3},auto)`,
                            //gridTemplateColumns: `repeat(${column},auto-fill, minmax(100px, 1fr))`,
                            //gridGap: "10px",
                            marginRight: "auto",
                            transform: "scale(0.7)",
                            //WebkitTransform:"rotate(90deg)",
                            position: "absolute",
                            left: 15,
                            top: 10,
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          {array1.map((array, index) => (
                            <div>
                              <div
                                className="each-slide"
                                key={index}
                                style={{
                                  padding: `${
                                    index <= 2 ? 35 : 25
                                  }px ${right1}px 10px ${left1}px`,
                                  borderRadius: `${borderradius}`,
                                  backgroundColor: "white",
                                  width: "280px",
                                  height: "200px",
                                }}
                              >
                                <div
                                  style={{
                                    // padding: `28px ${right1}px 10px ${left1}px`,
                                    borderRadius: `${borderradius}`,
                                    backgroundColor: "white",
                                    // width: "280px",
                                    // height: "250px",
                                  }}
                                  id="title"
                                >
                                  <div
                                    style={{
                                      textAlign: "center",
                                      fontWeight: "bold",
                                      color: "#000",
                                      fontSize: `${height}px`,
                                    }}
                                  >
                                    {text1}
                                  </div>
                                  <Barcode
                                    value={text}
                                    id="barcode"
                                    format={type}
                                    fontSize={20}
                                    font={font}
                                    lineColor={color1}
                                    textAlign={center}
                                    width={width}
                                    height={size}
                                  />
                                  <div style={{ display: "flex" }}>
                                    <div
                                      style={{
                                        fontFamily: `${font}`,
                                        fontSize: `${height}px`,
                                        color: "#000",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                        paddingLeft: "20px",
                                      }}
                                    >
                                      <strong>SP:{sp}</strong>
                                    </div>
                                    <div
                                      style={{
                                        fontFamily: `${font}`,
                                        fontSize: `${height}px`,
                                        fontWeight: "bold",
                                        textAlign: "right",
                                        paddingLeft: "70px",
                                        color: "#000",
                                      }}
                                    >
                                      <strong>MRP:{text2}</strong>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  padding: `30px ${right1}px 10px ${left1}px`,
                                  borderRadius: `${borderradius}`,
                                  backgroundColor: "white",
                                  width: "280px",
                                  height: "180px",
                                }}
                              ></div>
                              <div
                                style={{
                                  padding: `30px ${right1}px 10px ${left1}px`,
                                  borderRadius: `${borderradius}`,
                                  backgroundColor: "white",
                                  width: "280px",
                                  height: "180px",
                                }}
                              ></div>
                              <br />
                            </div>
                          ))}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
            <h6
              style={{
                padding: "360px 0px 5px 0px",
                textAlign: "center",
              }}
            >
              Barcode Size: {width}X{size}{" "}
            </h6>
          </div>
        </div>
        {/* </Modal> */}
        <div
          style={{
            display: "flex",
            right: "0%",
            position: "absolute",
            bottom: "0%",
            padding: "10px",
          }}
        >
          <div style={{ padding: "10px" }}>
            {/* <button style={{backgroundColor:"#67748E",width:"80px",}} onClick={print} >print</button> */}
          </div>
          <div style={{ padding: "10px" }}></div>
        </div>
      </div>

      {/* {shopProfile.userType === "Shop" &&
        mainUserShopDetails.length === 0 && (
          <TabPanel
            value={value}
            index={1}
            style={{
              background: "#fff",
              height: "calc(100vh - 170px)",
              overflowY: "auto",
              overflowX: "hidden",
              padding: "4rem 1rem 1rem",
            }}
          >
            <div
              style={{
                position: "relative",
              }}
            >
              <Button
                style={{
                  position: "absolute",
                  top: "-3.5rem",
                  right: "1rem",
                  borderRadius: "8px",
                  backgroundColor: "#EF4667",
                  color: "#fff",
                }}
                onClick={handleClick}
              >
                + Add outlet
              </Button>
              <Row gutter={[16, 16]}>
                {outletArray.map((data) => (
                  <Col span="6" key={data.userId}>
                    <OutletCard
                      area={data.outletArea}
                      address={data.shopAddress}
                      onEdit={() => handleEdit(data)}
                    />
                  </Col>
                ))}
                {outletArray?.length === 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50% ,-50%)",
                    }}
                  >
                    No Data to display{" "}
                  </div>
                )}
              </Row>
            </div>
          </TabPanel>
        )}
      {shopDetails.shopType !== "Restaurant" && (
        <TabPanel
          value={value}
          index={2}
          style={{
            background: "#fff",
            height: "calc(100vh - 170px)",
            overflowY: "auto",
            overflowX: "hidden",
            padding: "1rem",
            width: "100%",
            maxWidth: "-webkit-fill-available",
            maxWidth: "-moz-available",
            maxWidth: "fill-available",
            backgroundColor: "#F5F9FC",
          }}
        >
          <div>
            <div style={{ backgroundColor: "rgb(253, 251, 232)" }}>
              <button
                className={
                  invoice === true
                    ? "B-tabs1 B-tabsButton1 B-active-tabs1"
                    : "B-tabs1 B-tabsButton1"
                }
                onClick={() => {
                  setinvoice(true);
                  setdesign(false);
                }}
              >
                INVOICE FIELD
              </button>
              <button
                className={
                  design === true
                    ? "B-tabs1 B-tabsButton1 B-active-tabs1"
                    : "B-tabs1 B-tabsButton1"
                }
                onClick={() => {
                  setdesign(true);
                  setinvoice(false);
                }}
                style={{ width: "235px" }}
              >
                DESIGN
              </button>
            </div>

            <div
              className="B-content-tabs "
              style={{
                maxWidth: "-webkit-fill-available",
                maxWidth: "-moz-available",
                maxWidth: "fill-available",
                backgroundColor: "#F5F9FC",
              }}
            >
              <div
                className={
                  invoice === true
                    ? "B-content  B-active-content"
                    : "B-content"
                }
              >
                <Invoice />
              </div>
              <div
                className={
                  design === true
                    ? "B-content  B-active-content"
                    : "B-content"
                }
              >
                <Design />
              </div>
            </div>
          </div>
        </TabPanel>
      )} */}
    </Card>
  );
}
